import { Link } from 'react-router-dom';
import { comics, categories } from '@/mocks/comics';

export default function HotRanking() {
  const topComics = [...comics].sort((a, b) => b.rating - a.rating).slice(0, 8);

  return (
    <section className="py-16 px-4 md:px-6 bg-foreground-950">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-10 gap-4">
          <div className="flex items-center gap-4">
            <span className="inline-block px-4 py-1.5 rounded-full border border-white/20 text-white text-sm whitespace-nowrap">热门排行</span>
          </div>
          <div className="lg:w-2/3">
            <h2 className="text-3xl md:text-5xl font-bold text-white leading-tight" style={{ fontFamily: 'var(--font-heading)' }}>
              全网最热韩漫<br />大家都在追的神作
            </h2>
          </div>
        </div>

        <div className="overflow-x-auto pb-4 -mx-4 px-4">
          <div className="flex gap-5 min-w-max">
            {topComics.map((comic, idx) => (
              <Link
                key={comic.id}
                to={`/article/${comic.slug}`}
                className="group flex-shrink-0 w-[200px] md:w-[220px] cursor-pointer"
              >
                <div className="relative rounded-lg overflow-hidden bg-background-100 mb-3">
                  <div className="aspect-[3/4] overflow-hidden">
                    <img
                      src={comic.coverImage}
                      alt={comic.title}
                      title={`${comic.title} - 韩漫在线阅读`}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                      loading="lazy"
                    />
                  </div>
                  <div className="absolute top-2 left-2 w-7 h-7 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-xs font-bold">
                    {idx + 1}
                  </div>
                </div>
                <h3 className="text-sm font-semibold text-white mb-1 line-clamp-1">{comic.title}</h3>
                <div className="flex items-center gap-3 text-xs text-white/60">
                  <span>{comic.author}</span>
                  <span className="text-accent-400 font-semibold">★ {comic.rating}</span>
                </div>
              </Link>
            ))}
          </div>
        </div>

        <div className="mt-12 grid grid-cols-2 sm:grid-cols-4 gap-4">
          {categories.slice(0, 4).map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="flex items-center gap-3 px-5 py-4 rounded-lg bg-white/5 border border-white/10 hover:bg-white/10 transition-colors cursor-pointer group"
            >
              <div className="w-10 h-10 rounded-lg bg-accent-500/20 flex items-center justify-center flex-shrink-0">
                <i className={`${cat.icon} text-lg text-accent-400`}></i>
              </div>
              <div>
                <p className="text-sm font-semibold text-white whitespace-nowrap">{cat.name}</p>
                <p className="text-xs text-white/50 line-clamp-1">{cat.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}